import React, { useEffect, useState } from 'react';
import ClientNavbar from './ClientNavbar';
import './Page-css/ClientDashboard.css';
import { useAuth } from '../../Context/UserContext';
import ClientNavbar2 from './ClientNavbar2';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import target from '../../Assests/taskimage.png'
import { url } from '../../constants/url';
import { toast } from 'react-toastify';
import ClientNavbar1 from './ClientNavbar1';
import AssignProject from '../Modal/AssignProject';
import { RetestRequestSideBar } from '../Modal/RetestRequestSideBar';
import { faDownload, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ClientDashboard = () => {

  const { isSidebarCollapsed } = useAuth();
  const [assignProject, setAssignProject] = useState(false);
  const [retestRequest, setRetestRequest] = useState(false);
  const { emailVer, logout, userRole, userPermission } = useAuth();

  const [ongoing, setOngoing] = useState(0)
  const [criticalIssues, setCriticalIssues] = useState(0)
  const [fixVerified, setFixVerified] = useState(0)
  const [opened, setOpened] = useState(0)
  const [inprogress, setInprogress] = useState(0)
  const [closed, setClosed] = useState(0)
  const [closedDate, setClosedDate] = useState(0)
  const [deadline, setDeadline] = useState(0)
  const [deadlineToFix, setDeadlineToFix] = useState('')

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [dashboardProject, setDashboardProject] = useState([])
  const [projectData, setProjectData] = useState('')
  const [projectCritical, setProjectCritical] = useState(0)
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [assignedEngineer, setAssignedEngineer] = useState(0)
  const [vulnerabilities, setVulnerabilities] = useState([])
  const [resources, setResources] = useState([])
  const [developerVulList, setDeveloperVulList] = useState([])
  const [activityData, setActivityData] = useState([])
  const [scopeFileName, setScopeFileName] = useState('')

  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const [urlCount, setURLCount] = useState(0)

  const [loading, setLoading] = useState(false);

  const [severitySummary, setSeveritySummary] = useState({
    Critical: 0,
    High: 0,
    Medium: 0,
    Low: 0,
    Info: 0
  });


  const [overviewContent, setOverviewContent] = useState(true)
  const [scopeContent, setScopeContent] = useState(false)
  const [VulnerabilityContent, setVulnerabilityContent] = useState(false)
  const [timelineContent, setTimelineContent] = useState(false)
  const [teamContent, setTeamContent] = useState(false)
  const [reportContent, setReportContent] = useState(false)

  const statusPriority = {
    "Inprogress": 1,
    "Retesting": 2,
    "Completed": 3,
  };

  const [developersSuggestions, setDevelopersSuggestions] = useState()
  const [developer, setDeveloper] = useState('')
  const [developerError, setDeveloperError] = useState('')
  const [dueDate, setDueDate] = useState('')
  const [dueDateError, setDueDateError] = useState('')
  const [vulnerabilityId, setVulnerabilityId] = useState(null)
  const [rows, setRows] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [projectId, setProjectId] = useState(null)

  const location = useLocation();

  const navigate = useNavigate()

  const [hovered, setHovered] = useState(false);

  const handleOverview = () => {
    setOverviewContent(true)
    setScopeContent(false)
    setVulnerabilityContent(false)
    setTimelineContent(false)
    setTeamContent(false)
    setReportContent(false)
  }

  const handleScope = () => {
    setOverviewContent(false)
    setScopeContent(true)
    setVulnerabilityContent(false)
    setTimelineContent(false)
    setTeamContent(false)
    setReportContent(false)
  }

  const fetchDevelopers = async () => {
    try {
      const response = await fetch(`${url}/fetchdeveloper`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      })

      const data = await response.json()

      setDevelopersSuggestions(data)
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleVulnerabilities = () => {
    setOverviewContent(false)
    setScopeContent(false)
    setVulnerabilityContent(true)
    setTimelineContent(false)
    setTeamContent(false)
    fetchDevelopers()
    setReportContent(false)
  }

  const handleTimeline = () => {
    setOverviewContent(false)
    setScopeContent(false)
    setVulnerabilityContent(false)
    setTimelineContent(true)
    setTeamContent(false)
    setReportContent(false)
  }

  const handleTeam = () => {
    setOverviewContent(false)
    setScopeContent(false)
    setVulnerabilityContent(false)
    setTimelineContent(false)
    setTeamContent(true)
    setReportContent(false)
  }

  const handleReport = () => {
    setOverviewContent(false)
    setScopeContent(false)
    setVulnerabilityContent(false)
    setTimelineContent(false)
    setTeamContent(false)
    setReportContent(true)
    fetchClientDocument(selectedProjectId)
  }

  const getStatus = (status) => {
    if (status === 'Inprogress') {
      return 'status_inprogress';
    } else if (status === 'Closed') {
      return 'status_closed';
    } else if (status === 'Open') {
      return 'status_open';
    } else if (status === 'Reopen') {
      return 'status_reopen'
    } else if (status === 'Fixed') {
      return 'status_fixed'
    } else if (status === 'Not Fixed') {
      return 'status_not_fixed'
    } else if (status === 'NA') {
      return 'status_na';
    }
    return '';
  };

  const getVulStatus = (severity) => {
    switch (severity) {
      case 'Critical':
        return 'critical';
      case 'High':
        return 'high';
      case 'Medium':
        return 'medium';
      case 'Low':
        return 'low';
      case 'Info':
        return 'info';
      default:
        return '';
    }
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const formatNewDate = (dateString) => {
    const inputDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();

    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (d1, d2) =>
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear();

    if (isSameDay(inputDate, today)) {
      return "Today";
    } else if (isSameDay(inputDate, yesterday)) {
      return "Yesterday";
    } else {
      return inputDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
  };

  const scrollProjectList = (direction) => {
    const wrapper = document.getElementById('project-scroll-wrapper');
    if (!wrapper) return;

    const scrollAmount = wrapper.offsetWidth - 40; // scroll almost one full view
    wrapper.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };


  // Refer vulnerability.js file for backend code
  const fetchVulnerabilityCount = async () => {
    try {
      const response = await fetch(`${url}/fetchdashboardvulnerability`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json"
        },
        credentials: 'include',
      });

      if (response.status === 200) {
        const data = await response.json();
        setCriticalIssues(data.pending);
        setFixVerified(data.fixedVulnerability);
        setOpened(data.opened);
        setInprogress(data.inprogress)
        setClosed(data.closed);
        setClosedDate(data.closedToday)
        setDeadline(data.count)
      }

      if (response.status === 440) {
        return navigate('/')
      }

    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  // Refer project.js file for backend code
  const fetchProjectDetails = async () => {
    try {
      const response = await fetch(`${url}/clientprojectcount`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      if (response.status === 440) {

        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return logout()
      }
      const projects = await response.json();

      setOngoing(projects)

    } catch (error) {
      console.log(error);
    }
  };

  const fetchTeamActivity = async (id) => {
    try {
      console.log('fetchTeamActivity', id)
      const response = await fetch(`${url}/readactivity?projectId=${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      })

      const data = await response.json()
      setActivityData(data)

    } catch (error) {
      console.log(error)
    }
  }

  const handleProjectSelect = async () => {
    try {
      const response = await fetch(`${url}/clientdashboarddata`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      const data = await response.json();

      const sorted = [...(data.project || [])].sort((a, b) => {
        return (statusPriority[a.status] ?? 99) - (statusPriority[b.status] ?? 99);
      });

      setDashboardProject(sorted);

      // Use location.state.projectId if it exists
      const targetProjectId = location.state?.projectId || sorted[0]?._id;
      console.log('targetProjectId', targetProjectId)

      if (targetProjectId) {
        setSelectedProjectId(targetProjectId);
        setProjectId(targetProjectId);
        fetchProjectsDetails(targetProjectId);
        fetchClientDocument(targetProjectId);
        fetchTeamActivity(targetProjectId);
        fetchVulnerabilityCount();
        fetchScope(targetProjectId)
      }

    } catch (error) {
      console.error(error);
    }
  };

  const fetchProjectsDetails = async (projectId) => {
    try {
      console.log('fetchProjectsDetails', projectId)
      setLoading(true);
      const response = await fetch(`${url}/dashboardprojectdetails?projectId=${projectId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      const data = await response.json();
      setProjectCritical(data.filteredVulnerability)
      setAssignedEngineer(data.developerCount)
      setProjectData(data.projectData)

      const sortedVulnerability = data.vulnerabilities?.sort((a, b) => {
        const statusOrder = ["unassigned", "inprogress", "reopen", "closed"];
        const statusA = (a.bugStatus || '').toLowerCase();
        const statusB = (b.bugStatus || '').toLowerCase();

        return statusOrder.indexOf(statusA) - statusOrder.indexOf(statusB);
      });

      setVulnerabilities(sortedVulnerability)
      setResources(data.developers)
      setURLCount(data.urlCount)

      const countsInput = Array.isArray(data.vulnerabilityCount)
        ? data.vulnerabilityCount
        : [data.vulnerabilityCount];

      const severityCounts = countsInput.reduce(
        (acc, level) => {
          acc[level] = (acc[level] || 0) + 1;
          return acc;
        },
        {
          Critical: 0,
          High: 0,
          Medium: 0,
          Low: 0,
          Info: 0
        }
      );

      setSeveritySummary(severityCounts)

      const sortedVulnerabilityData = data.vulnerabilityData?.sort((a, b) => {
        const statusOrder = ["unassigned", "inprogress", "reopen", "closed"];
        const statusA = (a.bugStatus || '').toLowerCase();
        const statusB = (b.bugStatus || '').toLowerCase();

        return statusOrder.indexOf(statusA) - statusOrder.indexOf(statusB);
      });

      setDeveloperVulList(sortedVulnerabilityData)


      if (data.deadline) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const deadline = new Date(data.deadline);
        deadline.setHours(0, 0, 0, 0);

        const timeDifference = deadline - today;
        const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

        setDeadlineToFix(daysDifference);
      }


    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const handleDeveloperAssign = async () => {
    if (developer === '') {
      setDeveloperError('Developer name required')
      return;
    }
    if (dueDate === '') {
      setDueDateError('Due date required')
      return;
    }
    try {
      const response = await fetch(`${url}/assignprojectdeveloper`, {
        method: "POST",
        headers: {
          "Content-Type": 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          developer: developer,
          projectId: projectData._id,
          vulnerabilityId: vulnerabilityId,
          dueDate: dueDate
        })
      })

      if (response.status === 200) {
        setDeveloper('')
        setDueDate('')
        setAssignProject(false)
        fetchProjectsDetails(projectData._id)
        toast.success("Vulnerability Assigned Successfully", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
      if (response.status === 403) {
        toast.error("You cannot assign for yourself", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
      if (response.status === 401) {
        toast.error("Only project owner can assign", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
      if (response.status === 406) {
        toast.error("This vulnerability has already assigned to the selected user.", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }

    } catch (error) {
      console.log(error)
    }
  }

  const handleInitiatePentest = async () => {
    try {
      const response = await fetch(`${url}/initiatenewpentest`, {
        method: 'POST',
        headers: {
          "Content-Type": 'application/json'
        },
        credentials: 'include',
      })
      if (response.status === 200) {
        toast.success("Request sent!...", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
      if (response.status === 400) {
        toast.error("Bad request", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Refer file.js file for backend code
  const fetchClientDocument = async (projectId) => {
    try {
      console.log('document', projectId)
      const response = await fetch(`${url}/getfiles?projectid=${projectId}`, {
        method: 'GET',
        credentials: 'include'
      });

      if (response.status === 440) {
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return logout();
      }

      if (response.status === 404) {
        setUploadedFiles([]);
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch documents");
      }

      // ✅ Safely handle empty body
      const text = await response.text();
      const data = text ? JSON.parse(text) : [];
      setUploadedFiles(data);

    } catch (error) {
      console.error("Error fetching client documents:", error);
    }
  };


  const handleDownload = async (filename) => {
    try {
      const response = await fetch(`${url}/download/${filename}?projectId=${projectId}`, {
        method: 'GET',
        credentials: 'include'
      });
      if (response.status === 401) {
        toast.error("Unauthorized Access", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return;
      }
      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return;
      }
      const blob = await response.blob();
      const fileUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const fetchScope = async (projectId) => {
    try {
      const response = await fetch(`${url}/projectscope?projectId=${projectId}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      });

      const data = await response.json()
      fetchScopeContent(projectId, data?.file?.fileName)
      setScopeFileName(data?.file?.fileName)
    } catch (error) {
      console.error("Error fetching scope:", error);
    }
  };

  const fetchScopeContent = async (projectId, fileName) => {
    try {
      const response = await fetch(`${url}/pojectscopecontent`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify({ projectId, fileName })
      })
      if (!response.ok) {
        throw new Error("Failed to fetch content");
      }

      const data = await response.json();
      if (data && Array.isArray(data)) {
        setRows(data);
      } else {
        setRows([])
      }

    } catch (error) {
      console.log(error)
    }
  }

  const previewRows = Array.isArray(rows) ? rows.slice(0, 2) : [];

  const previewCols =
    rows && rows.length > 0 && rows[0] && typeof rows[0] === "object"
      ? Object.keys(rows[0] || {}).slice(0, 3)
      : [];

  useEffect(() => {
    if (
      projectData?.applicationType &&
      [
        "VA Scan",
        "Configuration Review",
        "External Network Penetration Testing",
        "Internal Network Penetration Testing",
      ].includes(projectData.applicationType)
    ) {
      fetchScope(projectData._id);
    }
  }, [projectData?.applicationType]);

  const totalVulnerabilities = developerVulList?.length;

  const closedCount = developerVulList?.filter(vuln => vuln.bugClosedStatus).length;
  const fixedCount = developerVulList?.filter(vuln => vuln.bugFixedStatus).length;
  const reopenCount = developerVulList?.filter(vuln => vuln.bugStatus === 'Reopen').length;


  const completedCount = closedCount; // Or: closedCount + fixedCount;

  const completionPercentage = totalVulnerabilities > 0
    ? Math.round((completedCount / totalVulnerabilities) * 100)
    : 0;



  useEffect(() => {
    if (emailVer.endsWith('@isecurion.com')) {
      logout();
      return;
    }
    fetchProjectDetails();
    fetchVulnerabilityCount();
    handleProjectSelect()

  }, []);

  useEffect(() => {
    const checkScroll = () => {
      const content = document.getElementById('project-scroll-content');
      const wrapper = document.getElementById('project-scroll-wrapper');
      if (content && wrapper) {
        setShowScrollButtons(content.scrollWidth > wrapper.clientWidth);
      }
    };

    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, [dashboardProject]);



  return (
    <div className="client-dashboard">

      <div>
        <div className='client_navabr1'>
          <ClientNavbar1 />
        </div>
        <div className='navbar_second'><ClientNavbar2 /></div>
      </div>

      <div className='wrap_navbar_dashboard'>
        <div className={isSidebarCollapsed ? 'clientdash-navbar' : 'clientdash_close_navbar'}>
          <ClientNavbar />
        </div>
        <div className='wrap_dashboard_data'>
          <div className='wrap_data_all'>
            {userPermission !== 'level 4' ? (
              <div className='wrap_section1_widget'>
                <div className='open_vuln'>
                  <div>
                    <h3>Ongoing Projects</h3>
                    <p>{ongoing}</p>
                  </div>
                  <Icon icon="mage:file-3" width="24" height="24" color='#2563EB' />
                </div>
                <div className='pending_critical'>
                  <div>
                    <h3>Pending Critical Issues</h3>
                    <p>{criticalIssues}</p>
                  </div>
                  <Icon icon="mynaui:danger-triangle" width="24" height="24" color='#EF4444' />
                </div>
                <div className='upcoming'>
                  <div>
                    <h3>Upcoming Deadline</h3>
                    <p>{deadline}</p>

                  </div>
                  <Icon icon="hugeicons:calendar-check-in-01" width="24" height="24" color='#16A34A' />
                </div>
                <div className='fix_verified'>
                  <div>
                    <h3>Fixes Verified</h3>
                    <p>{fixVerified}</p>
                  </div>
                  <Icon icon="material-symbols-light:order-approve-outline-rounded" width="24" height="24" color='#A250ED' />
                </div>
              </div>
            ) : (
              <div className='wrap_section1_widget'>
                <div className='open_vuln'>
                  <div>
                    <h3>Open Vulnerabilities</h3>
                    <p>{opened}</p>
                  </div>
                  <Icon icon="lucide:package-open" width="24" height="24" color='#2563EB' />
                </div>
                <div className='pending_critical'>
                  <div>
                    <h3>In Progress Fixes</h3>
                    <p>{inprogress}</p>
                  </div>
                  <Icon icon="mdi:progress-clock" width="24" height="24" color='#EF4444' />
                </div>
                <div className='upcoming'>
                  <div>
                    <h3>Fix Ready for Retest</h3>
                    <p>{closed}</p>
                  </div>
                  <Icon icon="mdi:recycle" width="24" height="24" color='#16A34A' />
                </div>
                <div className='fix_verified'>
                  <div>
                    <h3>Resolve Today</h3>
                    <p>{closedDate}</p>
                  </div>
                  <Icon icon="ei:gear" width="30" height="30" color='#A759EE' />
                </div>
              </div>
            )}


            <div className='wrap_section2_heading'>

              <div style={{ maxWidth: '100vw', overflow: 'hidden' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    backgroundColor: '#E76A341A',
                    padding: '2px',
                    width: showScrollButtons ? '100%' : 'fit-content',
                  }}
                >
                  {/* Left Scroll Button */}
                  {showScrollButtons && (
                    <button
                      onClick={() => scrollProjectList('left')}
                      style={{
                        fontSize: '20px',
                        padding: '8px 5px 1px 5px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      <Icon icon="fluent:ios-arrow-24-filled" width="22" height="22" />
                    </button>
                  )}

                  {/* Scroll Wrapper */}
                  <div
                    id="project-scroll-wrapper"
                    style={{
                      overflowX: 'hidden',
                      flexGrow: 1,
                      maxWidth: '90vw',
                    }}
                  >
                    <div
                      id="project-scroll-content"
                      style={{
                        display: 'flex',
                        gap: '8px',
                        scrollBehavior: 'smooth',
                        width: 'max-content',
                        marginLeft: showScrollButtons ? '0px' : '5px',
                      }}
                    >
                      {dashboardProject?.map((project) => (
                        <div className="section2_list" key={project._id}>
                          <button
                            className={project._id === selectedProjectId ? 'first-project' : 'other-project'}
                            onClick={() => {
                              setSelectedProjectId(project._id);
                              fetchProjectsDetails(project._id);
                              fetchClientDocument(project._id);
                              fetchScope(project._id)
                              fetchTeamActivity(project._id);
                              fetchVulnerabilityCount();
                              setProjectId(project._id);
                            }}
                          >
                            {project.projectName}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Right Scroll Button */}
                  {showScrollButtons && (
                    <button
                      onClick={() => scrollProjectList('right')}
                      style={{
                        fontSize: '20px',
                        padding: '7px 5px 3px 5px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        transform: 'rotate(180deg)',
                      }}
                    >
                      <Icon icon="fluent:ios-arrow-24-filled" width="22" height="22" />
                    </button>
                  )}
                </div>
              </div>



              {userPermission !== 'level 4' ? (
                dashboardProject && selectedProjectId && (() => {
                  const selectedProject = dashboardProject.find(project => project._id === selectedProjectId);
                  if (!selectedProject) return null;

                  return (
                    <div className='section2_data'>
                      <h2>
                        Project Status:
                        {selectedProject.status === 'Inprogress'
                          ? ' In Progress'
                          : selectedProject.status === 'Pending'
                            ? ' Not Started'
                            : (selectedProject.status)}
                      </h2>
                      <div className="progress-container">


                        <div className='progress-container-bar'>
                          <div className="custom-stepper-bar">
                            {/* Step 1: Project Kickoff */}
                            <div className="stepper-step">
                              <span className={`stepper-icon ${projectData.projectKickoff ? 'completed' : 'incompleted'}`}>
                                <Icon icon="qlementine-icons:check-tick-small-16" width="30" height="30" />
                              </span>
                            </div>
                            <div className={`stepper-line ${projectData.testStartDate !== null ? 'completed' : 'incompleted'}`}></div>

                            {/* Step 2: Test Initiated (Assuming same as kickoff here) */}
                            <div className="stepper-step">
                              <span className={`stepper-icon ${projectData.testStartDate !== null ? 'completed' : 'incompleted'}`}>
                                <Icon icon="qlementine-icons:check-tick-small-16" width="30" height="30" />
                              </span>
                            </div>
                            <div className={`stepper-line ${projectData.phase1Status ? 'completed' : 'incompleted'}`}></div>

                            {/* Step 3: Phase 1 */}
                            <div className="stepper-step">
                              <span className={`stepper-icon ${projectData.phase1Status ? 'completed' : 'incompleted'}`}>
                                <Icon icon="qlementine-icons:check-tick-small-16" width="30" height="30" />
                              </span>
                            </div>
                            <div className={`stepper-line ${projectData.retestStatus ? 'completed' : 'incompleted'}`}></div>

                            {/* Step 4: Retest */}
                            <div className="stepper-step">
                              <span className={`stepper-icon ${projectData.retestStatus ? 'completed' : 'incompleted'}`}>
                                <Icon icon="qlementine-icons:check-tick-small-16" width="30" height="30" />
                              </span>
                            </div>
                            <div className={`stepper-line ${projectData.completionReportStatus ? 'completed' : 'incompleted'}`}></div>

                            {/* Step 5: Completion Report */}
                            <div className="stepper-step">
                              <span className={`stepper-icon ${projectData.completionReportStatus ? 'completed' : 'incompleted'}`}>
                                <Icon icon="qlementine-icons:check-tick-small-16" width="30" height="30" />
                              </span>
                            </div>
                            <div className={`stepper-line ${projectData.completionReportStatus ? 'completed' : 'incompleted'}`}></div>

                            {/* Step 6: Final (Assuming same status) */}
                            <div className="stepper-step">
                              <span className={`stepper-icon ${projectData.completionReportStatus ? 'completed' : 'incompleted'}`}>
                                <Icon icon="qlementine-icons:check-tick-small-16" width="30" height="30" />
                              </span>
                            </div>
                          </div>

                          <div className='custom-stepper-bar-steps'>
                            <div className='stepper-step'>
                              <p className='kickoff'>Kickoff</p>
                            </div>
                            <div className='stepper-step'>
                              <p className='Test-Initiated'>Test Initiated</p>
                            </div>
                            <div className='stepper-step'>
                              <p className='Phase-1-Completed'>Phase 1 Completed</p>
                            </div>
                            <div className='stepper-step'>
                              <p className='Retest-Initiated'>Retest Initiated</p>
                            </div>
                            <div className='stepper-step'>
                              <p className='Phase-2-Completed'>Phase 2 Completed</p>
                            </div>
                            <div className='stepper-step'>
                              <p className='Certification'>All Done</p>
                            </div>
                          </div>
                        </div>
                        <div className='wrap_section2_widget'>
                          <div className='critical_issues'>
                            <div>
                              <h3>Pending Critical Issues</h3>
                              <p>{projectCritical}</p>
                            </div>

                            <Icon icon="mynaui:danger-triangle" width="24" height="24" color='#EF4444' />

                          </div>
                          <div className='pending_retest'>
                            <div>

                              <h3>Pending Retests</h3>
                              <p>{projectData.status === 'Inprogress' ? 'Yes' : 'No'}</p>
                            </div>
                            <Icon icon="material-symbols-light:pending-actions-sharp" width="24" height="24" color='#16A34A' />
                          </div>
                          <div className='assigned_developers'>
                            <div>

                              <h3>Assigned Engineers</h3>
                              <p>{assignedEngineer}</p>
                            </div>
                            <Icon icon="garden:user-follow-stroke-16" width="24" height="24" color='#A250ED' />
                          </div>
                          <div className='fix_progress'>
                            <div>
                              <h3>Vulnerability Overview</h3>
                              <p style={{ fontSize: '12.5px', marginTop: '-4px', marginLeft: "0px" }}>
                                Total: {severitySummary.Critical + severitySummary.High + severitySummary.Medium + severitySummary.Low + severitySummary.Info} |
                                <span style={{ marginLeft: '8px' }}>
                                  Fixed: {vulnerabilities?.filter(vul => vul.retestStatus === 'Fixed').length}
                                </span> |
                                <span style={{ marginLeft: '8px' }}>
                                  Not Fixed: {vulnerabilities?.filter(vul => vul.retestStatus === 'Not Fixed').length}
                                </span>
                              </p>
                            </div>
                            <Icon icon="solar:bug-outline" width="24" height="24" color='#2563EB' />
                          </div>
                        </div>

                      </div>

                    </div>
                  );
                })()

              ) : (
                <div className='section2_data'>
                  <h2>My Remediation Progress</h2>
                  <p>Across all assigned vulnerabilities</p>
                  <div className="progress-container1">
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: `${completionPercentage}%` }}>{completionPercentage}% </div>
                      {completionPercentage === 0 && <span style={{
                        color: '#fff',
                        paddingLeft: `10px`,
                      }}>
                        0%
                      </span>}
                    </div>
                  </div>
                </div>

              )}

              {userPermission !== 'level 4' ? (
                <div className='wrap_project_section_container'>
                  <div className='wrap_project_section'>
                    <div style={{ marginTop: '-1px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                      <button onClick={handleOverview} className={overviewContent ? 'overview_active' : 'overview_inactive'}>Overview</button>
                      <button onClick={handleScope} className={scopeContent ? 'overview_active' : 'overview_inactive'}>Scope</button>
                      <button onClick={handleVulnerabilities} className={VulnerabilityContent ? 'overview_active' : 'overview_inactive'}>Vulnerabilities</button>
                      <button onClick={handleTimeline} className={timelineContent ? 'overview_active' : 'overview_inactive'}>Timeline</button>
                      <button onClick={handleTeam} className={teamContent ? 'overview_active' : 'overview_inactive'}>Team</button>
                      <button onClick={handleReport} className={reportContent ? 'overview_active' : 'overview_inactive'}>Reports</button>
                    </div>
                  </div>

                </div>
              ) : ''}

              {userPermission !== 'level 4' ? (
                overviewContent && (
                  <div className='wrap_section2_overview'>
                    <div className='wrap_section2_vuln'>
                      <h2>Project Overview</h2>
                      <p>{projectData.applicationType !== 'VA Scan' &&
                        projectData.applicationType !== 'Configuration Review' &&
                        projectData.applicationType !== 'External Network Penetration Testing' &&
                        projectData.applicationType !== 'Internal Network Penetration Testing'
                        ? `Product Lead`
                        : `Infrastructure Lead`} : {projectData.developerLeadName ? projectData.developerLeadName : 'Not Assigned'}</p>
                      <p>{projectData.applicationType !== 'VA Scan' &&
                        projectData.applicationType !== 'Configuration Review' &&
                        projectData.applicationType !== 'External Network Penetration Testing' &&
                        projectData.applicationType !== 'Internal Network Penetration Testing'
                        ? `Application Type`
                        : `Infrastructure Type`} : {projectData?.applicationType}</p>
                      <p>Audit Lead : {projectData.teamLead ? projectData.teamLead : 'Not Assigned'}</p>
                      {projectData.applicationType !== 'VA Scan' &&
                        projectData.applicationType !== 'Configuration Review' &&
                        projectData.applicationType !== 'External Network Penetration Testing' &&
                        projectData.applicationType !== 'Internal Network Penetration Testing'
                        ? (<p>Environment Type : {projectData?.environmentType}</p>)
                        : ''}
                      <p>
                        Severity:
                        <span className="severity-box critical">Critical</span>{severitySummary.Critical},&nbsp;
                        <span className="severity-box high">High</span>{severitySummary.High},&nbsp;
                        <span className="severity-box medium">Medium</span>{severitySummary.Medium},&nbsp;
                        <span className="severity-box low">Low</span>{severitySummary.Low},&nbsp;
                        <span className="severity-box informational">Info</span>{severitySummary.Info}
                      </p>
                      {projectData.applicationType !== 'VA Scan' &&
                        projectData.applicationType !== 'Configuration Review' &&
                        projectData.applicationType !== 'External Network Penetration Testing' &&
                        projectData.applicationType !== 'Internal Network Penetration Testing'
                        ? (
                          <div>
                            <h2>Scope</h2>
                            <p>No. of URLs : {urlCount}</p>
                          </div>
                        ) : ''}


                    </div>
                    <div className='wrap_section2_assign'>
                      <h2>Uploaded Vulnerabilities</h2>
                      <div className='wrap_section2_table_wrappe'>
                        <table className='wrap_section2_table'>
                          <thead>
                            <tr>
                              <th>CVE ID</th>
                              <th>Issue</th>
                              <th>Assigned To</th>
                              <th>Status</th>
                              <th>Due</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {vulnerabilities.length === 0 ? (
                              <tr className="collapsetable">
                                <td colSpan="6" style={{ textAlign: 'center' }}>No Vulnerabilities....</td>
                              </tr>
                            ) : (
                              vulnerabilities.map((vul, index) => {
                                const dueDate = new Date(vul.dueDate);
                                const today = new Date();
                                const diffTime = dueDate - today;
                                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                return (
                                  <tr key={index}>
                                    <td>{vul.cveId}</td>
                                    <td>{vul.vulnerabilityName}</td>
                                    <td>{vul.developerName || <button style={{ fontSize: '14px', paddingBottom: '6px' }} onClick={() => {
                                      setAssignProject(true)
                                      setVulnerabilityId(vul._id)
                                      fetchDevelopers()
                                    }}>Assign Engineer</button>}</td>
                                    <td>
                                      <span className={`status-badge status-${vul.bugStatus?.toLowerCase().replace(/\s/g, '')}`}>
                                        {vul.bugStatus === 'Inprogress' ? 'In Progress' : vul.bugStatus}
                                      </span>
                                    </td>
                                    <td>
                                      {vul.bugStatus === "Closed"
                                        ? "-"
                                        : isNaN(diffDays)
                                          ? 'N/A'
                                          : diffDays > 0
                                            ? `${diffDays} day(s)`
                                            : '-'}
                                    </td>
                                    <td>
                                      <Link to={`/viewvulnerabilities/${vul._id}`} style={{ color: "white" }}>
                                        <button
                                          onMouseEnter={() => setHoveredIndex(index)}
                                          onMouseLeave={() => setHoveredIndex(null)} >
                                          <Icon
                                            icon={hoveredIndex === index ? 'iconamoon:eye-light' : 'humbleicons:eye-close'}
                                            width="20"
                                            height="20"
                                          />
                                        </button>
                                      </Link>
                                    </td>
                                  </tr>
                                )
                              }))}

                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                )
              ) : (
                <div className='wrap_section2_overview'>
                  <div className='wrap_section2_vuln'>
                    <h2>Vulnerability Overview</h2>
                    <p>Total Assigned: {developerVulList.length}</p>
                    {/* <p>
                      Severity:
                      <span className="severity-box critical">Critical</span>{severitySummary.Critical},&nbsp;
                      <span className="severity-box high">High</span>{severitySummary.High},&nbsp;
                      <span className="severity-box medium">Medium</span>{severitySummary.Medium},&nbsp;
                      <span className="severity-box low">Low</span>{severitySummary.Low},&nbsp;
                      <span className="severity-box informational" >Info</span>{severitySummary.Info}
                    </p> */}

                    <div className='severity-container'>
                      <div className='severity-box1 critical1'>
                        <div>
                          <span className='severity_name'>Critical </span>
                          <span className='severity_count'>
                            {severitySummary.Critical}
                          </span>
                        </div>
                      </div>
                      <div className='severity-box1 high1'>
                        <div>
                          <span className='severity_name'>High </span>
                          <span className='severity_count'>
                            {severitySummary.High}
                          </span>
                        </div>
                      </div>
                      <div className='severity-box1 medium1'>
                        <div>
                          <span className='severity_name'>Medium </span>
                          <span className='severity_count'>
                            {severitySummary.Medium}
                          </span>
                        </div>
                      </div>
                      <div className='severity-box1 low1'>
                        <div>
                          <span className='severity_name'>Low </span>
                          <span className='severity_count'>
                            {severitySummary.Low}
                          </span>
                        </div>
                      </div>
                      <div className='severity-box1 informational1'>
                        <div>
                          <span className='severity_name'>Info </span>
                          <span className='severity_count'>
                            {severitySummary.Info}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* <p>Audit Team Lead: {projectData?.teamLead}</p> */}
                    {userPermission !== 'level 4' ? (
                      <div>
                        <h2>Scope</h2>
                      </div>
                    ) : ''}
                  </div>
                  <div className='wrap_section2_assign'>
                    <h2>Assigned Vulnerabilities</h2>

                    <div className='wrap_section2_table_wrappe'>

                      <table className='wrap_section2_table'>
                        <thead>
                          <tr>
                            <th>CVE ID</th>
                            <th>Title</th>
                            <th>Severity</th>
                            <th>Status</th>
                            <th>Due</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {developerVulList.length === 0 ? (
                            <tr className="collapsetable">
                              <td colSpan="7" style={{ textAlign: 'center' }}>Vulnerabilities Not Assigned....</td>
                            </tr>
                          ) : (
                            developerVulList.map((vul, index) => {

                              const dueDate = new Date(vul.dueDate);
                              const today = new Date();
                              const diffTime = dueDate - today;
                              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                              return (
                                <tr key={index}>
                                  <td>{vul.cveId}</td>
                                  <td>{vul.vulnerabilityName}</td>
                                  <td>
                                    <span className={`severity-badge status-${vul.severity?.toLowerCase().replace(/\s/g, '')}`}>
                                      {vul.severity}
                                    </span>
                                  </td>
                                  <td>
                                    <span className={`status-badge status-${vul.bugStatus?.toLowerCase().replace(/\s/g, '')}`}>
                                      {vul.bugStatus === 'Inprogress' ? 'In Progress' : (vul.bugStatus)}
                                    </span>
                                  </td>
                                  <td>
                                    {vul.bugStatus === "Closed"
                                      ? "-"
                                      : isNaN(diffDays)
                                        ? 'N/A'
                                        : diffDays > 0
                                          ? `${diffDays} day(s)`
                                          : '-'}
                                  </td>
                                  <td><Link to={`/viewvulnerabilities/${vul._id}`} style={{
                                    color: "white"
                                  }}>
                                    <button
                                      onMouseEnter={() => setHoveredIndex(index)}
                                      onMouseLeave={() => setHoveredIndex(null)} >
                                      <Icon
                                        icon={hoveredIndex === index ? 'iconamoon:eye-light' : 'humbleicons:eye-close'}
                                        width="20"
                                        height="20"
                                      />
                                    </button>
                                  </Link></td>
                                </tr>
                              )
                            }))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              <div className='wrap_section3_data'>
                {userPermission !== 'level 4' ? (
                  overviewContent && (
                    <div className='wrap_section3_deadlines'>
                      <h2>Resources</h2>
                      <div className='wrap_section3_deadlines_table_wrapper'>
                        <table className='resource_table'>
                          <thead>
                            <tr>
                              <th>Sl No</th>
                              <th>Name</th>
                              <th>Email Id</th>
                            </tr>
                          </thead>
                          <tbody>
                            {resources.length === 0 ? (
                              <tr className="collapsetable">
                                <td colSpan="5" style={{ textAlign: 'center' }}>Resource Not Found....</td>
                              </tr>
                            ) : (
                              resources.map((dev, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{dev.name}</td>
                                  <td>{dev.email}</td>
                                </tr>
                              )))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )

                ) : (
                  <div className='wrap_section3_deadlines'>
                    <h2>Upcoming Deadlines</h2>
                    <div className='wrap_section3_deadlines_table_wrapper'>


                      {developerVulList.length === 0 ? (
                        ''
                      ) : (
                        developerVulList.map((vul, index) => {
                          // Skip if dueDate is null, undefined, or empty string
                          if (!vul.dueDate) {
                            return null;
                          }

                          const dueDate = new Date(vul.dueDate);
                          const today = new Date();

                          const diffTime = dueDate - today;
                          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                          return (
                            <ul key={index}>
                              <li>
                                {vul.vulnerabilityName} – due in {diffDays > 0 ? `${diffDays} day(s)` : 'today or past due'}
                              </li>
                            </ul>
                          );
                        })

                      )
                      }
                    </div>
                  </div>
                )}


                {userPermission !== 'level 4' ? (
                  overviewContent && (
                    <div className='wrap_section3_activity'>
                      <h2>Team Activity Snapshot</h2>
                      <div className='wrap_section3_activity_scroll'>
                        {Array.isArray(activityData) && activityData.map((activity, index) => (
                          <div className='wrap_section3_activity_data' key={index}>
                            <h5>{activity.message}</h5>
                            <p>{formatNewDate(activity.createdAt)}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                ) : (
                  <div className='wrap_section3_activity'>
                    <h2>Recent Activity</h2>
                    <div className='wrap_section3_activity_scroll'>
                      {Array.isArray(activityData) && activityData.map((activity, index) => (
                        <div className='wrap_section3_activity_data' key={index}>
                          <h5>{activity.message}</h5>
                          <p>{formatNewDate(activity.createdAt)}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              </div>

              {overviewContent && (
                <div className='wrap_section4_data'>
                  {userPermission !== 'level 4' ? (
                    <div className='wrap_section4_deadlines'>
                      <h2>Actions</h2>
                      <div className='wrap_section4_buttons'>
                        <div className='wrap_section4_button'>
                          <Icon icon="mdi:users-add" width="16" height="16" />
                          <button onClick={handleInitiatePentest}>Initiate New Pentest</button>
                        </div>
                        <div className='wrap_section4_button' onClick={() => {
                          setRetestRequest(true)
                        }}>
                          <Icon icon="eva:repeat-fill" width="16" height="16" />
                          <button>Request Retest</button>
                        </div>
                      </div>
                    </div>
                  ) : ''}
                </div>
              )}


              {scopeContent && (
                userPermission !== 'level 4' ? (
                  <div className='wrap_scope_details'>
                    <div className='wrap_targets'>
                      <h2>Testing Targets</h2>
                      {projectData ? (
                        <div className='wrap_url_details'>
                          <div className='wrap_application_details'>
                            <h5>
                              {projectData.applicationType !== 'VA Scan' &&
                                projectData.applicationType !== 'Configuration Review' &&
                                projectData.applicationType !== 'External Network Penetration Testing' &&
                                projectData.applicationType !== 'Internal Network Penetration Testing'
                                ? `${projectData.applicationType} Application`
                                : projectData.applicationType}
                            </h5>

                            <p>{projectData.applicationType !== 'VA Scan' && projectData.applicationType !== 'Configuration Review' && projectData.applicationType !== 'External Network Penetration Testing' && projectData.applicationType !== 'Internal Network Penetration Testing' ? (projectData.scope) : ''}</p>
                          </div>
                          <div className='wrap_status_application'>
                            <button>{projectData.status === 'Inprogress' ? 'In Progress' : projectData.status}</button>
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
                          <img style={{ width: "80px", height: "80px" }} src={target} alt='Vulnytics - Pentest as a service' />
                        </div>
                      )}

                      {projectData.applicationType !== 'VA Scan' && projectData.applicationType !== 'Configuration Review' && projectData.applicationType !== 'External Network Penetration Testing' && projectData.applicationType !== 'Internal Network Penetration Testing' ? '' : (
                        <div className='wrap_scope_tables'>
                          {Array.isArray(previewCols) && previewCols.length === 0 ? (
                            <div>
                              <p style={{ marginTop: '40px', color: 'red' }}>No Records Found</p>
                            </div>
                          ) : (
                            <>
                              <div className='wrap_inside_scope_table'>
                                <table>
                                  <thead>
                                    <tr>
                                      {previewCols.map((col, i) => (
                                        <th style={{
                                          wordBreak: "break-word",
                                          width: `${100 / previewCols.length}%`,
                                          padding: "6px",
                                        }}
                                          key={i}>
                                          {col || "-"}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {previewRows.map((row, i) => (
                                      <tr key={i}>
                                        {previewCols.map((col, j) => (
                                          <td key={j}>
                                            {row[col] || "-"}
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>

                              <div className="wrap_scope_read_more">
                                {rows.length > 0 &&
                                  (rows.length > 3 || Object.keys(rows[0] || {}).length > 2) && (
                                    <button onClick={() => setShowModal(true)}>
                                      Read More
                                    </button>
                                  )}
                              </div>


                              {showModal && (
                                <div className='wrap_scope_full_content'>
                                  <div className='wrap_scope_content_details'>
                                    <div className='wrap_file_name_heading'>
                                      <h2>{scopeFileName}</h2>
                                      <p onClick={() => setShowModal(false)}>X</p>
                                    </div>

                                    <div className='wrap_scope_content_table'>
                                      <table>
                                        <thead>
                                          <tr>
                                            {Object.keys(rows[0]).map((col, i) => {
                                              const colName = col?.toString().toLowerCase().trim();
                                              const isSerialCol = ["sl.no", "sl no", "no", "#", "number", "no.", "num", "sl no.", "sl.no.", "slno", "sno",].includes(colName);

                                              return (
                                                <th
                                                  key={i}
                                                  style={{
                                                    width: isSerialCol ? "80px" : "auto",
                                                    wordBreak: "break-word",
                                                    padding: "6px",
                                                  }}
                                                >
                                                  {col}
                                                </th>
                                              );
                                            })}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {rows.map((row, i) => (
                                            <tr key={i}>
                                              {Object.entries(row).map(([col, val], j) => {
                                                const colName = col?.toString().toLowerCase().trim();
                                                const isSerialCol = ["sl.no", "sl no", "no", "#", "number", "no.", "num", "sl no.", "sl.no.", "slno", "sno",].includes(colName);

                                                return (
                                                  <td
                                                    key={j}
                                                    style={{
                                                      width: isSerialCol ? "80px" : "auto",
                                                    }}
                                                  >
                                                    {val || "-"}
                                                  </td>
                                                );
                                              })}
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>


                                  </div>
                                </div>
                              )}</>

                          )}

                        </div>
                      )}


                    </div>
                    <div className='wrap_testing_method'>
                      <h2>Testing Methodology</h2>
                      <p>Standards & Framework</p>
                      <div className='wrap_frameworks'>
                        {projectData.applicationType === 'IOS' || projectData.applicationType === 'ANDROID' || projectData.applicationType === 'ANDROID & IOS' || projectData.applicationType === 'WEB' || projectData.applicationType === 'API' || projectData.applicationType === 'Desktop App' ? <h3>OWASP Top 10</h3> : ''}
                        {projectData.applicationType === 'WEB' || projectData.applicationType === 'API' ? <h3>Nist Framework</h3> : ''}
                        {projectData.applicationType === 'WEB' ? <h3>Custom Checks</h3> : ''}
                        {projectData.applicationType === 'Secure Code Review' ? <h3>OWASP Code Review</h3> : ''}
                        {projectData.applicationType === 'Secure Code Review' ? <h3>CERT</h3> : ''}
                        {projectData.applicationType === 'Secure Code Review' ? <h3>SANS Top 25</h3> : ''}
                        {projectData.applicationType === 'IOS' || projectData.applicationType === 'ANDROID' || projectData.applicationType === 'ANDROID & IOS' ? <h3>MSTG</h3> : ''}
                        {projectData.applicationType === 'IOS' || projectData.applicationType === 'ANDROID' || projectData.applicationType === 'ANDROID & IOS' ? <h3>SANS-25</h3> : ''}
                        {projectData.applicationType === 'IOS' || projectData.applicationType === 'ANDROID' || projectData.applicationType === 'ANDROID & IOS' ? <h3>MASVS</h3> : ''}
                        {[
                          "VA Scan",
                          "Configuration Review",
                          "External Network Penetration Testing",
                          "Internal Network Penetration Testing"
                        ].includes(projectData.applicationType) && (
                            <>
                              <h3>OWASP</h3>
                              <h3>PTES</h3>
                              <h3>OSSTMM</h3>
                              <h3>NIST</h3>
                            </>
                          )}

                      </div>
                    </div>
                  </div>
                ) : ''

              )}

              {VulnerabilityContent && (
                <div className='wrap_discoverd_vul'>
                  <div className='wrap_list_vul'>
                    <h2>Discovered Vulnerabilities</h2>
                    <p>Detailed list of all security vulnerabilities found during testing</p>
                    {vulnerabilities &&
                      [...vulnerabilities]
                        .sort((a, b) => {
                          const order = ["critical", "high", "medium", "low", "info"];
                          return (
                            order.indexOf(a.severity.toLowerCase()) -
                            order.indexOf(b.severity.toLowerCase())
                          );
                        })
                        .map((vul, index) => (
                          <div className='wrap_vul_list_details' key={index}>
                            <div className='wrap_vul_details'>
                              <div className='wrap_vul_name_data'>
                                <p>{vul.vulnerabilityName}</p>
                                <div>
                                  <h2
                                    className={`severity-vul status-${vul.severity
                                      .toLowerCase()
                                      .replace(/\s/g, "")}`}
                                  >
                                    {vul.severity}
                                  </h2>
                                  <h3 className={getStatus(vul.bugStatus)}>
                                    {vul.bugStatus === "Inprogress"
                                      ? "In Progress"
                                      : vul.bugStatus}
                                  </h3>
                                  {vul.retestStatus && (
                                    <h3 className={getStatus(vul.retestStatus)}>
                                      {vul.retestStatus === "NA"
                                        ? "Not Applicable"
                                        : vul.retestStatus}
                                    </h3>
                                  )}
                                </div>
                                <div className='vulnerability_two_button'>
                                  <button
                                    onClick={() => {
                                      setAssignProject(true);
                                      setVulnerabilityId(vul._id);
                                    }}
                                  >
                                    {vul.bugStatus === "Unassigned" || vul.bugStatus === null
                                      ? "Assign Engineer"
                                      : "Reassign"}
                                  </button>

                                  <button
                                    onClick={() =>
                                      navigate(`/viewvulnerabilities/${vul._id}`)}>
                                    Details
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className='wrap_description_vul'>
                              <p>{vul.description}</p>
                            </div>
                            <div className='wrap_vul_additional_data'>
                              <p>CVSS: {vul.cvssScore}</p>
                              <p className='parameter'>
                                Affected Parameter: {vul.affectedParameter}
                              </p>
                              <p>Discovered: {formatDate(vul.discovered)}</p>
                            </div>
                          </div>
                        ))}

                  </div>
                </div>
              )}

              {timelineContent && (
                <div className='wrap_project_timeline'>
                  <div className='wrap_timeline_data'>
                    <h2>Project Timeline</h2>
                    <p style={{ marginBottom: '30px' }}>Key milestone and activities throughout the project</p>
                    <div className="timeline">
                      {projectData.projectKickoff === true && projectData.testStartDate ? (
                        <div className="timeline-item">
                          <div className="timeline-left">
                            <span className="dot milestone"></span>
                            <div className="content">
                              <p className="title">Project kickoff and planning</p>
                              <span className="tag">Milestone</span>
                            </div>
                          </div>
                          <div className="timeline-right">
                            <p>{formatDate(projectData.testStartDate)}</p>
                          </div>
                        </div>
                      ) : null}

                      {projectData.projectKickoff === true && projectData.testStartDate ? (
                        <div className="timeline-item">
                          <div className="timeline-left">
                            <span className="dot milestone"></span>
                            <div className="content">
                              <p className="title">Reconnaissance phase completed</p>
                              <span className="tag">Milestone</span>
                            </div>
                          </div>
                          <div className="timeline-right">
                            <p>{formatDate(projectData.testStartDate)}</p>
                          </div>
                        </div>
                      ) : null}


                      {projectData.vulnerabilityStatus === true ? (
                        vulnerabilities && vulnerabilities.map((vul, index) => (
                          <div className="timeline-item">
                            <div className="timeline-left">
                              <span className="dot vulnerability"></span>
                              <div className="content">
                                <p className="title">{vul.vulnerabilityName}</p>
                                <span className="tag">Vulnerability</span>
                              </div>
                            </div>
                            <div className="timeline-right">
                              <p>{formatDate(vul.discovered)}</p>
                            </div>
                          </div>
                        ))
                      ) : ''}

                      {projectData.testEndDateStatus === true ? (
                        <div class="timeline-item">
                          <div className="timeline-left">
                            <span className="dot milestone"></span>
                            <div className="content">
                              <p className="title">Security Audit Completed</p>
                              <span className="tag">Milestone</span>
                            </div>
                          </div>
                          <div className="timeline-right">
                            <p>{formatDate(projectData.testEndDate)}</p>
                          </div>
                        </div>
                      ) : ''}

                      {projectData.phase1Status === true ? (
                        <div class="timeline-item">
                          <div className="timeline-left">
                            <span className="dot activity"></span>
                            <div className="content">
                              <p className="title">Phase 1 Report Uploaded</p>
                              <span className="tag">Activity</span>
                            </div>
                          </div>
                          <div className="timeline-right">
                            <p>{formatDate(projectData.phase1ReportDate)}</p>
                          </div>
                        </div>
                      ) : ''}

                      {projectData.retestStatus === true ? (
                        <div class="timeline-item">
                          <div className="timeline-left">
                            <span className="dot milestone"></span>
                            <div className="content">
                              <p className="title">Retest Applied</p>
                              <span className="tag">Activity</span>
                            </div>
                          </div>
                          <div className="timeline-right">
                            <p>{formatDate(projectData.retestStatusDate)}</p>
                          </div>
                        </div>
                      ) : ''}

                      {projectData.completionReportStatus === true ? (
                        <div class="timeline-item">
                          <div className="timeline-left">
                            <span className="dot activity"></span>
                            <div className="content">
                              <p className="title">Completion Report Uploaded</p>
                              <span className="tag">Activity</span>
                            </div>
                          </div>
                          <div className="timeline-right">
                            <p>{formatDate(projectData.phase2ReportDate)}</p>
                          </div>
                        </div>
                      ) : ''}

                      {projectData.projectCompStatus === true ? (
                        <div class="timeline-item">
                          <div className="timeline-left">
                            <span className="dot complete"></span>
                            <div className="content">
                              <p className="title">Project Completed</p>
                              <span className="tag">Milestone</span>
                            </div>
                          </div>
                          <div className="timeline-right">
                            <p>{formatDate(projectData.projectCompDate)}</p>
                          </div>
                        </div>
                      ) : ''}


                    </div>
                  </div>
                </div>
              )}

              {teamContent && (
                <div className='wrap_team_content'>
                  <div className='wrap_team_list_data'>
                    {projectData.applicationType !== 'VA Scan' &&
                      projectData.applicationType !== 'Configuration Review' &&
                      projectData.applicationType !== 'External Network Penetration Testing' &&
                      projectData.applicationType !== 'Internal Network Penetration Testing'
                      ? (<h2>Project Team</h2>)
                      : (<h2>Infrastructure Team</h2>)}
                    <p>Security professionals working on your project</p>

                    <div className='wrap_team_data'>
                      <div className='wrap_product_team'>
                        {projectData.applicationType !== 'VA Scan' &&
                          projectData.applicationType !== 'Configuration Review' &&
                          projectData.applicationType !== 'External Network Penetration Testing' &&
                          projectData.applicationType !== 'Internal Network Penetration Testing'
                          ? (<h2>Project Team</h2>)
                          : (<h2>Infrastructure Team</h2>)}
                        <div className='wrap_grid_team'>
                          {projectData.developerLeadName ? (
                            <div className='wrap_product_member'>
                              <h4>{projectData.developerLeadName ? projectData.developerLeadName.slice(0, 2).toUpperCase() : ''}</h4>
                              <div>
                                <p>{projectData.developerLeadName}</p>
                                <h2>Team Lead</h2>
                              </div>
                            </div>
                          ) : (<p>Team Lead Not Assigned</p>)}

                          {resources ? resources.map((dev, index) => (
                            <div className='wrap_product_member' key={index}>
                              <h4>{dev.name ? dev.name.slice(0, 2).toUpperCase() : ''}</h4>
                              <div>
                                <p>{dev.name}</p>
                                <h2>{dev.role}</h2>
                              </div>
                            </div>
                          )) : ''}



                        </div>
                      </div>

                      <div className='wrap_audit_team'>
                        <h2>Security Audit Team</h2>
                        <div className='wrap_security_audit_team'>
                          {projectData && projectData.teamLead ? (
                            <div className='wrap_audit_member'>
                              <h4>{projectData.teamLead.slice(0, 2).toUpperCase()}</h4>
                              <div>
                                <p>{projectData.teamLead}</p>
                                <h2>Project Lead</h2>
                              </div>
                            </div>
                          ) : (
                            <p>Not Assigned</p>
                          )}

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              )}

              {reportContent && (
                <div className='wrap_section7_deadlines'>
                  <h2>Uploaded Reports</h2>
                  <div className='wrap_section7_deadline_scroll'>
                    {uploadedFiles && uploadedFiles.length > 0 ? (
                      uploadedFiles.map((doc, index) => (
                        <div className='wrap_section7_download' key={index}>
                          <p>
                            <FontAwesomeIcon icon={faFileLines} />
                          </p>
                          <h2 style={{ wordBreak: 'break-all' }}>
                            {doc.fileName}
                          </h2>
                          <i>
                            <FontAwesomeIcon
                              icon={faDownload}
                              onClick={() => handleDownload(doc.fileName)}
                              style={{ cursor: 'pointer' }}
                            />
                          </i>
                        </div>
                      ))
                    ) : (
                      <p style={{ color: '#888', display: 'flex', marginTop: '50px' }}>
                        No reports available
                      </p>
                    )}
                  </div>
                </div>
              )}


            </div>
          </div>
        </div >
      </div >

      <AssignProject
        assignSidebar={assignProject}
        setAssignSidebar={setAssignProject}
        who={'vulnerabilities'}
        developersSuggestions={developersSuggestions}
        setDevelopersSuggestions={setDevelopersSuggestions}
        developer={developer}
        setDeveloper={setDeveloper}
        dueDate={dueDate}
        setDueDate={setDueDate}
        handleDeveloperAssign={handleDeveloperAssign}
      />

      <RetestRequestSideBar retestRequest={retestRequest} setRetestRequest={setRetestRequest} projectId={projectId} />
    </div >
  );
};

export default ClientDashboard;